import { Component, OnInit } from '@angular/core';
import { ERROR_134 } from 'src/app/shared/constants/abre-cuentas.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { IncomesService } from 'src/app/shared/services/incomes/incomes.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';

@Component({
  selector: 'app-max-products-error',
  templateUrl: './max-products-error.component.html',
  styleUrls: ['./max-products-error.component.scss'],
})
export class MaxProductsErrorComponent implements OnInit {
  errorInfo: any;
  close = false;
  items: any;

  constructor(
    public copyService: CopyService,
    public navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private parameterService: ParametersService,
    private incomesService: IncomesService,
    private bitacoraService: BitacoraService) {
  }

  /**
   * Summary Get data sent to show the component depending on each case
   */
  ngOnInit() {
    this.errorInfo = ERROR_134.DATA;
    this.items = this.abreCuentasService.getProductsMax();
    this.close = true;
  }

  showClose() {
    this.navigationService.loadExitScreen = true;
  }

  clickTwoLinkOnb(event) {
    const optionSelected = this.copyService.copies.header_exit_button;
    switch (event.type) {
      case 'action1':
        const bitacoraEvent = `exit_process`;
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        break;
      case 'action2':
        console.log('10', optionSelected.action2);
        break;
    }
    this.navigationService.loadExitScreen = false;
  }

  next() {
    let namesnocontinue = '';
    const filteredNoContinue = this.abreCuentasService.getProductsSelects().filter(value =>
      this.items.some(some => value.flow === some.flow),
    );
    filteredNoContinue.forEach(element => {
      namesnocontinue += '_' + element.product_type;
    });
    this.bitacoraService.saveDataInBitacora('product_politics' + namesnocontinue);
    const filteredContinue = this.abreCuentasService.getProductsSelects().filter(value => !this.items.some(some => value.flow === some.flow));
    filteredContinue.forEach((element, index) => {
      element.prioritizeForClient = index + 1;
    });
    this.abreCuentasService.setProductsSelects(filteredContinue);
    if (filteredContinue.length === 1) {
      this.abreCuentasService.setMultiView(false);
      let products = this.abreCuentasService.getPostlogin() ? this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE) :
        this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
      this.abreCuentasService.setproductSelected(products.filter(fil => fil.flow === filteredContinue[0].flow)[0]);
      this.incomesService.callIncomes();
      this.navigationService.goToFlowSteps(filteredContinue[0].flow, 'identification', 'pep-validation');
      if (this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
        this.navigationService.getPhase(filteredContinue[0].flow, 'client-data-update-tc').start = 'update-data';
      } else {
        const newStep = this.navigationService.getPhase(filteredContinue[0].flow, 'client-data-update-tc');
        newStep.steps['insurability'].next['200'] = 'update-data';
      }
      this.navigationService.getCurrentPhase().steps['identification-summary'].postValidate = null;
    } else {
      this.navigationService.navigateTo('pep-validation');
    }
  }
}
